import React from 'react'
import { useNavigate } from 'react-router-dom'
import intl from 'react-intl-universal'
import { DownFill, AddCircleOutline } from 'antd-mobile-icons'
import RecommendProduct from '../../components/ProductMenu/RecommendProduct'
import { getScopeParam } from '../../utils/session/store'
import PlusIcon from '../../components/Icon/PlusIcon'
import HotProducts from '../../components/ProductMenu/HotProducts'
import { addBehaviorsRecord } from '../../utils/BehaviorstatsHelp'
export default function RecomProductCard({ stores = [], viewAll = true }) {

    const navigate = useNavigate()

    const renderProductActions = ({ item, cls, stepperOption = {} }) => {
        return <div onClick={() => {
            toSeeProduct({ product: item, name: item.name, storeId: item.storeId })
        }} style={{ paddingRight: 6 }}>
            <PlusIcon width={24} height={24} color={stepperOption.iconColor || "var(--adm-color-primary)"} />
        </div>
    }

    const handleClickImageAction = (item) => {
        console.log(item, '===///item==////')
        // toSeeProduct({ product: item, name: item.name, storeId: item.storeId })
    }

    const toSeeProduct = ({ product, storeId, name }) => {
        const { areaId, partnerId } = getScopeParam() || {}
        let text = `areaid=${areaId}&partnerid=${partnerId}&hotel=${name}&storeid=${storeId}&productid=${product?.productId || ''}`

        navigate(`/carte?${text}`)
    }
    return <>
        {
            stores.map((item, index) => {
                const { shortName = '', name = '' } = item
                const storeName = shortName || name
                console.log(item, '===///item==////')
                return (
                    <div className='pd-card-wrapper m-b-sm' key={index}>
                        <div className='pd-card-header'>
                            <div
                                className='pd-card-title jm-flex-item ellips'
                            >
                                <span>{storeName}</span>
                            </div>
                            {viewAll && <div
                                className='check-all'
                                onClick={() => {
                                    toSeeProduct({ product: null, name: storeName, storeId: item.storeId })
                                    addBehaviorsRecord({
                                        behaviorType: 160200,
                                        behavior: 160205,
                                        storeId: item.storeId,
                                    })
                                }}>
                                    {intl.get('h_check_all').d('Check all')} <DownFill style={{ transform: 'rotate(-90deg)' }} />
                                    </div>}
                        </div>
                        <div>
                            {/* <RecommendProduct
                                list={item.products}
                                events={{
                                    renderProductActions,
                                    handleClickImageAction: product => {
                                        toSeeProduct({ product, name: storeName, storeId: item.storeId })
                                    }
                                }} /> */}
                            <HotProducts
                                storeInfo={item}
                                list={item.products}
                                events={{
                                    renderProductActions,
                                    handleClickImageAction: product => {
                                        toSeeProduct({ product, name: storeName, storeId: item.storeId })
                                    }
                                }}
                                actionC={1}
                            />
                        </div>

                    </div>
                )
            })
        }

    </>


}
